import React, { useState, useContext } from 'react';
import PermissionGrid from '../components/Permissions/PermissionGrid';
import { PermissionContext } from '../components/Permissions/PermissionContext';

const PermissionPage = () => {
  const { permissions } = useContext(PermissionContext);
  const [selectedRoleId, setSelectedRoleId] = useState(permissions[0]?.roleId || 1);

  const handleRoleSelect = (roleId) => {
    setSelectedRoleId(roleId);
  };

  return (
    <div className="container py-4">
      <div className="card shadow-lg border-0 p-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h3 className="fw-bold text-primary">Permissions Management</h3>
        </div>
        <div className="row">
          <div className="col-md-5">
            <div className="mb-4">
              <h5 className="fw-bold text-secondary">Select Role</h5>
              <select
                className="form-select form-select-lg"
                value={selectedRoleId}
                onChange={(e) => handleRoleSelect(Number(e.target.value))}
              >
                {permissions.map((perm) => (
                  <option key={perm.roleId} value={perm.roleId}>
                    {perm.name} {/* Displays the role name */}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-md-7">
            <PermissionGrid roleId={selectedRoleId} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PermissionPage;
